// extracted by mini-css-extract-plugin
export default {"fullWidthContainer":"full-width-container-module--full-width-container--f6e4e"};